import { render, staticRenderFns } from "./exchangeIncomeReport.vue?vue&type=template&id=42a54078&"
import script from "./exchangeIncomeReport.vue?vue&type=script&lang=js&"
export * from "./exchangeIncomeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports